import CreateXMp4 from './CreateXMp4.mp4';
import CreateX_BG1 from './CreateX_BG1.png';
import CreateX_BG2 from './CreateX_BG2.png';
import CreateX_BG3 from './CreateX_BG3.png';
import CreateX_BG4 from './CreateX_BG4.png';
import CreateXWhite from './CreateXWhite.png';
import TechBizzClubDark from './TechBizzClubDark.png';
import MLVTEC from './MLVTEC.png';
import Rulebook from './CreateX2024_Rulebook.pdf';
import HashTrust from './HashTrust.png';
import InnovatechS from './InnovatechS.png';
import BitssTech from './Bitss_Tech.png';
import Infographic from './CreateX2024_Infographic.pdf';
import SponsorsMp4 from './Sponsors.mp4';
import MobileSponsors from './MobileSponsors.mp4';
import Unstop from './unstop.png';

export const Assets = {
    CreateXMp4: CreateXMp4,
    CreateX_BG1: CreateX_BG1,
    CreateXWhite: CreateXWhite,
    CreateX_BG2: CreateX_BG2,
    CreateX_BG3: CreateX_BG3,
    CreateX_BG4: CreateX_BG4,
    TechBizzClubDark: TechBizzClubDark,
    MLVTEC: MLVTEC,
    Rulebook: Rulebook,
    HashTrust: HashTrust,
    InnovatechS: InnovatechS,
    BitssTech: BitssTech,
    Infographic: Infographic,
    SponsorsMp4: SponsorsMp4,
    MobileSponsors: MobileSponsors,
    Unstop: Unstop,
};
